module.exports = __webpack_public_path__ + "static/media/map.1b0bb49b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/map.png
// module id = 853
// module chunks = 0